 document.addEventListener("DOMContentLoaded", function () {
/* DOM Content START  */ 
   var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1.5,
    spaceBetween: 70,
    freeMode: true,
    breakpoints: {
      479: {
        slidesPerView: 2.5,
        spaceBetween: 40,
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 35,
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 68,
      },
      1199: {
        slidesPerView: 4,
        spaceBetween: 68,
      },
    },
     
  });

    const detailsElements = document.querySelectorAll(".facets__disclosure-vertical");
     if(detailsElements){
       detailsElements.forEach(details => {
          details.setAttribute("open", "open");
      });
     }


   document.addEventListener('change', event => {
  if (event.target.matches('.swatch-input__input')) {
    const selectedInput = event.target; // Get the clicked input
    const selectedLabel = selectedInput.nextElementSibling; // Get the associated label
    const cardWrapper = selectedInput.closest('.card-wrapper'); // Find the closest card-wrapper
    const variantImage = selectedLabel.getAttribute('data-varaint-image'); // Get the variant image URL

    if (cardWrapper && variantImage) {
      const cardMedia = cardWrapper.querySelector('.card__media img');
      if (cardMedia) {
        cardMedia.setAttribute('src', variantImage);
        cardMedia.setAttribute('srcset', variantImage);
      }

      // Remove the active class from all labels within this card
      cardWrapper.querySelectorAll('.swatch-input__label').forEach(label => {
        label.classList.remove('active');
      });

      // Add the active class to the clicked label
      selectedLabel.classList.add('active');
    }
  }
});
   
   /* DOM Content END  */ 
});

/* Related Products */
(function initializeSwiper() {
  // Function to initialize Swiper
  function createSwiper() {
    const swiperContainer = document.querySelector('.related-prodcuts-lists');
    if (swiperContainer) {
      new Swiper(swiperContainer, {
        slidesPerView: 1.5,
        spaceBetween: 20,
        grabCursor: true,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: false,
          draggable: true,
        },
        breakpoints: {
          575: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 28,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 28,
          },
        },
      });
    }
  }

  // Check if the swiper container exists and initialize
  const swiperContainer = document.querySelector('.related-prodcuts-lists');
  if (swiperContainer) {
    createSwiper();
  } else {
    // If the swiper container is not found, use MutationObserver to wait for it
    const observer = new MutationObserver((mutationsList, observer) => {
      // Only observe for addition of the target element
      if (document.querySelector('.related-prodcuts-lists')) {
        createSwiper(); // Initialize Swiper
        observer.disconnect(); // Stop observing once it's initialized
      }
    });

    // Observe the body or a more specific parent element for changes (target more specific container if possible)
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();



